import { createContext } from "react";
export const WebsiteContext = createContext(undefined);
//# sourceMappingURL=WebsiteContext.js.map